jQuery(document).ready(function () {

    $(document).on("click", ".pack-option", function () {
        var value = $(".quantity__input").val(),
                price = $(this).attr("data-price"),
                totalPrice = parseInt(price) * parseInt(value);

        $(document).find(".price-custom-change").text(price);
    });



});

jQuery(document).on("click", function (e) {
    
  const $target = jQuery(e.target);

  // open popup
  if ($target.is(".size-chart-link")) {
    e.preventDefault();
    jQuery("#size-chart-content").addClass("active");
  }

  // close popup
  if ($target.is(".closesizepopup")) {
    e.preventDefault();
    jQuery("#size-chart-content").removeClass("active");
  }
});
function formatMoney(cents, format) {
    if (typeof cents === "string") {
        cents = cents.replace(/[^\d.-]/g, "");
        cents = parseFloat(cents);
    }

    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";

        if (isNaN(number) || number == null)
            return "0";

        number = (number / 100.0).toFixed(precision);
        var parts = number.split(".");
        var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
        var cents = parts[1] ? decimal + parts[1] : "";

        return dollars + cents;
    }

    var match = format && format.match(placeholderRegex);
    if (!match)
        return cents;

    switch (match[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        default:
            value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
}


document.addEventListener("DOMContentLoaded", function () {
  const firstAccordion = document.querySelector(".bottom-blocks .product__accordion details");
  if (firstAccordion) {
    firstAccordion.setAttribute("open", "");
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const sizeChartBox = document.querySelector(".custom-size-chartbox");
  const sizeChartContent = sizeChartBox?.querySelector("#size-chart-content");

  if (sizeChartContent) {
    document.body.appendChild(sizeChartContent);
  }
});


document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 767) {
    document.querySelectorAll(".product-payment-box .row").forEach((row, index) => {
      const paymentItems = row.querySelectorAll(".col-sm-4.col-12");
      if (paymentItems.length <= 1) return;

      // ✅ Unique swiper & pagination classes
      const swiperClass = `productPaymentSwiper-${index}`;
      const paginationClass = `productPaymentPagination-${index}`;

      // ✅ Create Swiper container
      const swiperContainer = document.createElement("div");
      swiperContainer.classList.add("swiper", swiperClass, "customProductPaymentSwiperContainer");

      // ✅ Create Swiper wrapper
      const swiperWrapper = document.createElement("div");
      swiperWrapper.classList.add("swiper-wrapper");

      // Move each .col item into swiper wrapper
      paymentItems.forEach(item => {
        item.classList.add("swiper-slide");
        swiperWrapper.appendChild(item);
      });

      // ✅ Add wrapper inside container
      swiperContainer.appendChild(swiperWrapper);

      // ✅ Create pagination (outside swiper but inside row)
      const pagination = document.createElement("div");
      pagination.classList.add("swiper-pagination", paginationClass);

      // ✅ Replace existing row content
      row.innerHTML = "";
      row.appendChild(swiperContainer);
      row.appendChild(pagination);

      // ✅ Initialize Swiper
      new Swiper(`.${swiperClass}`, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        grabCursor: true,
        speed: 700,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: `.${paginationClass}`,
          clickable: true,
        },
      });
    });
  }
});


$(document).ready(function(){
    $(document).on('click','.products-information .colors li',function(){
        var image = $(this).attr('data-image'),
            parent = $(this).closest('.product-card-outer'),
            target = $(parent).find('.product-img');
        $(parent).find('.colors li').removeClass('active')
        $(this).addClass('active');
        if( image != '' ){
            target.attr('src',image)
        }
    });

    // ✅ Initial image update on page load
    $('.product-card-outer').each(function(){
        var activeColor = $(this).find('.colors li.active');
        var image = activeColor.attr('data-image');
        var target = $(this).find('.product-img');
        if(image && image !== ''){
            target.attr('src', image);
        }
    });
});


